import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index';
import Login from "../view/Login";
import Home from "../view/Home";
import Member from "../view/Member";
import Clubs from "../view/Clubs";
import Club from "../view/Club";
import ClubMap from "../view/ClubMap";
import Events from "../view/Events";
import Friendly from '../view/Friendly';
import Settings from '../view/Settings';
import Notification from '../view/Notification';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/site',
        beforeEnter() {
            location.href = 'https://www.italiasoftair.it'
        }
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/member',
        name: 'member',
        component: Member,
        meta: {
            requiresAuth: true
        },
        props: true
    },
    {
        path: '/clubs',
        name: 'clubs',
        component: Clubs,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/club',
        name: 'club',
        component: Club,
        meta: {
            requiresAuth: true
        },
        props: true
    },
    {
        path: '/club-map',
        name: 'club-map',
        component: ClubMap,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/events',
        name: 'events',
        component: Events,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/friendly',
        name: 'friendly',
        component: Friendly,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: Notification,
        meta: {
            requiresAuth: true
        },
        props: true
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem(store.state.LST)) {
            next({name: 'login'})
        } else {
            next()
        }
    } else {
        next()
    }
});

export default router
